// Module
var code = "<div class=\"clickableAreaContainer\" data-role=\"container\"/>";
// Exports
export default code;